import { PinCodeClient } from '@frontend/pin-code/api';
import { PinCode, PinCodeRendering } from '@frontend/pin-code/types';
import { useEffect, useState } from 'react';
import { PinCodeViewProps } from './pin-code-view.component';

interface ViewProps {
    isLoading: boolean;
    pinCode?: PinCode;
    code?: string;
    rendering: PinCodeRendering;
}

const usePinCodeView = (props: PinCodeViewProps): ViewProps => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [pinCode, setPinCode] = useState<PinCode | undefined>(props.pinCode);
    const [code, setCode] = useState<string | undefined>(props.codeOverwrite);

    useEffect(() => {
        if (pinCode === undefined && props.entityId && props.entityType) {
            PinCodeClient.fetchPinCodes({entity_id: props.entityId, entity_type: props.entityType}).then((result) => {
                result.results.length > 0 && setPinCode(result.results[0]);
            }).finally(() => {
                setIsLoading(false);
            });
        } else setIsLoading(false);
    }, [pinCode, props.entityId, props.entityType]);

    useEffect(() => {
        if (pinCode) {
            setCode(props.codeOverwrite || pinCode.code);
        }
    }, [pinCode, props.codeOverwrite]);

    return {
        isLoading,
        pinCode,
        code: code,
        rendering: props.renderingOverwrite || pinCode?.rendering || PinCodeRendering.QR_CODE
    };
};

export default usePinCodeView;
